import * as React from "react";
import {useReducer} from "react";
import { itemDetailReducer } from "./itemDetailReducer";


export const ItemDetailContext = React.createContext([]);

export const withItemDetailContext = (Component) => {
    return props => {
        const [state, dispatch] = useReducer(itemDetailReducer,[]);
        return (
            <ItemDetailContext.Provider value={{state, dispatch}}>
                <Component {...props}></Component>
            </ItemDetailContext.Provider>
        )

    }
}
